/* eslint-disable */
import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthTokenService } from '../services/authentication/auth-token.service';
import { RoutingStateService } from '../services/routing-state.service';
import { isPublicRoute } from '../utils/util';

@Injectable()
export class AuthGuard {
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    // Authenticated ✔
    if (AuthTokenService.getAccessToken() || isPublicRoute()) {
      return true;
    }
    // no Authenticated ✘
    else {
      RoutingStateService.returnUrl =
        window.location.pathname +
        window.location.search.replaceAll('%25', '%').replaceAll('%3A', ':');
      this.router.navigate(['./account/login']);
      return false;
    }
  }
}
